import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { DishServices } from "../../services";
import { DishCreateAllergensPage } from "../../dish-create/dish-create-allergens/dish-create-allergens";
import { Globals } from "../../../../globals";
import { IngredientsServices } from '../../../ingredients/services';
import { HttpClient } from '@angular/common/http';
import { ConfigurationServices } from '../../../configuration/services';
import { StaticsServices } from '../../../services/statics';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { AIServices } from '../../../services/aiServices';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */


@Component({
    selector: 'page-dish-create-name',
    templateUrl: 'dish-create-name.html',
})

export class DishCreateNamePage {

    update_state: boolean = false;
    dish_uid: string;
    dish_name: string;
    isLoading: boolean = false;
    dish: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public fb: FormBuilder,
        public dishServices: DishServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public ingredientsServices: IngredientsServices,
        public http: HttpClient,
        public alertCtrl: AlertController,
        public configurationServices: ConfigurationServices,
        public staticsServices: StaticsServices,
        private translateService: TranslateService,
        private analyticsServices: AnalyticsServices,
        public aiServices: AIServices) {

        this.ingredientsServices.cleanArrayTmp(); // limpiamos array tmp de ingredientes

        //Params
        this.update_state = this.navParams.get('update');
        this.dish = this.navParams.get('dish');
        this.dish_name = this.navParams.get('name');

        //Si hacemos update adaptamos la informacion
        if (this.update_state) {
            this.dishServices.dish_tags = this.navParams.get('tags');
            this.dish_uid = this.navParams.get('dish_uid');
        } else {
            this.dishServices.dish_tags = Array();
        }

        this.dishServices.form = fb.group({
            name_es: [this.navParams.get('name')],
            name_en: [this.navParams.get('name_en')],
            name_fr: [this.navParams.get('name_fr')],
            name_it: [this.navParams.get('name_it')],
            name_de: [this.navParams.get('name_de')],
            name_ca: [this.navParams.get('name_ca')],
        });

        this.dishServices.form_desc = fb.group({
            description_es: [this.navParams.get('description_es')],
            description_en: [this.navParams.get('description_en')],
            description_fr: [this.navParams.get('description_fr')],
            description_it: [this.navParams.get('description_it')],
            description_de: [this.navParams.get('description_de')],
            description_ca: [this.navParams.get('description_ca')],
        });
    }

    ionViewWillLeave() {
        this.ingredientsServices.quick_create = false;
        this.ingredientsServices.quick_create_dish = false;
        this.ingredientsServices.quick_create_type = false;
    }

    submit() {
        if (this.dishServices.form.valid) {
            // Validar que haya al menos un tag seleccionado
            if (!this.dishServices.dish_tags || this.dishServices.dish_tags.length === 0) {
                let toast = this.toastCtrl.create({
                    message: this.translateService.instant('instant-introduce-categoria-plato-continuar'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
                return;
            }
            
            if (!this.update_state) {
                this.insert();
            } else {
                this.update();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translateService.instant('instant-introduce-nombre-plato-continuar'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    updateDefaultNames() {
        const mainName = this.dishServices.form.value.name_es;
        if (mainName) {
            const formValue = this.dishServices.form.value;
            if (!formValue.name_en) formValue.name_en = mainName;
            if (!formValue.name_fr) formValue.name_fr = mainName;
            if (!formValue.name_it) formValue.name_it = mainName;
            if (!formValue.name_de) formValue.name_de = mainName;
            if (!formValue.name_ca) formValue.name_ca = mainName;
            this.dishServices.form.patchValue(formValue);
        }
    }

    insert() {
        this.updateDefaultNames();
        this.dishServices.afs.collection('dish').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'name_es': this.dishServices.form.value.name_es,
            'name_en': this.dishServices.form.value.name_en,
            'name_fr': this.dishServices.form.value.name_fr,
            'name_it': this.dishServices.form.value.name_it,
            'name_de': this.dishServices.form.value.name_de,
            'name_ca': this.dishServices.form.value.name_ca,
            'description_es': this.dishServices.form_desc.value.description_es,
            'description_en': this.dishServices.form_desc.value.description_en,
            'description_fr': this.dishServices.form_desc.value.description_fr,
            'description_it': this.dishServices.form_desc.value.description_it,
            'description_de': this.dishServices.form_desc.value.description_de,
            'description_ca': this.dishServices.form_desc.value.description_ca,
            'tags': this.dishServices.dish_tags,
            'tags_static': this.dishServices.dish_tags.toString(),
            'foodcost_static': 0,
            'foodcost_parts': 1,
            'price': 0,
            'price_half': 0,
            'price_tapa': 0,
            'foodcost': Array(),
            'created_at': new Date(),
            'updated_at': new Date(),
        }).then(doc => {
            // Añadir tags nuevos al array global
            if (this.dishServices.dish_tags && this.dishServices.dish_tags.length > 0) {
                this.globals.addTagsToGlobal(this.dishServices.dish_tags);
            }
            this.globals.GAtrackView('Dish', 'Dish - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Dish', this.dishServices.form.value.name_es);
            this.analyticsServices.trackingExpArticles('create dish', this.globals.tracking_exp['create_article'], doc.id);
            //Get the UID Document
            this.globals.tourLaunchStep(4);
            this.sendData();
            this.finisher();
            this.navCtrl.push(DishCreateAllergensPage, {
                update: false,
                dish_uid: doc.id,
                dish_name: this.globals.nameLangSelectDish(this.dishServices.form.value),
                article_uid: doc.id,
                article_type: 'dish',
                dish: {
                    'UID_RESTAURANT': this.globals.restaurant_uid,
                    'name_es': this.dishServices.form.value.name_es,
                    'name_en': this.dishServices.form.value.name_en,
                    'name_fr': this.dishServices.form.value.name_fr,
                    'name_it': this.dishServices.form.value.name_it,
                    'name_de': this.dishServices.form.value.name_de,
                    'name_ca': this.dishServices.form.value.name_ca,
                    'description_es': this.dishServices.form_desc.value.description_es,
                    'description_en': this.dishServices.form_desc.value.description_en,
                    'description_fr': this.dishServices.form_desc.value.description_fr,
                    'description_it': this.dishServices.form_desc.value.description_it,
                    'description_de': this.dishServices.form_desc.value.description_de,
                    'description_ca': this.dishServices.form_desc.value.description_ca,
                    'tags': this.dishServices.dish_tags,
                    'tags_static': this.dishServices.dish_tags.toString(),
                    'foodcost_static': 0,
                    'foodcost_parts': 1,
                    'price': 0,
                    'price_half': 0,
                    'price_tapa': 0,
                    'foodcost': Array(),
                    'created_at': new Date(),
                    'updated_at': new Date(),
                }
            }).then(this.dishServices.dish_tags = null);
        });
    }

    update() {
        if (this.dishServices.dish_tags == undefined) {
            this.dishServices.dish_tags = [];
        }

        this.updateDefaultNames();

        this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
            'name_es': this.dishServices.form.value.name_es,
            'name_en': this.dishServices.form.value.name_en,
            'name_fr': this.dishServices.form.value.name_fr,
            'name_it': this.dishServices.form.value.name_it,
            'name_de': this.dishServices.form.value.name_de,
            'name_ca': this.dishServices.form.value.name_ca,
            'description_es': this.dishServices.form_desc.value.description_es,
            'description_en': this.dishServices.form_desc.value.description_en,
            'description_fr': this.dishServices.form_desc.value.description_fr,
            'description_it': this.dishServices.form_desc.value.description_it,
            'description_de': this.dishServices.form_desc.value.description_de,
            'description_ca': this.dishServices.form_desc.value.description_ca,
            'tags': this.dishServices.dish_tags,
            'tags_static': this.dishServices.dish_tags.toString(),
            'updated_at': new Date(),
        }).then(async () => {
            // Añadir tags nuevos al array global
            if (this.dishServices.dish_tags && this.dishServices.dish_tags.length > 0) {
                this.globals.addTagsToGlobal(this.dishServices.dish_tags);
            }
            this.globals.GAtrackView('Dish', 'Dish - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Dish', this.dishServices.form.value.name_es);
            this.analyticsServices.trackingExpArticles('update dish', this.globals.tracking_exp['update_article'], this.dish_uid);
            this.sendData();
            this.staticsServices.changeStateStaticWait(true);
            this.navCtrl.pop();
        });
    }

    sendData() {
        this.globals.dataSet('plat_name', this.dishServices.form.value.name_es, '', '');//Send dish data
        for (let value of this.dishServices.dish_tags) {
            this.globals.dataSet('plat_tag', value, '', this.dishServices.form.value.name_es);//Send dish tag's data
        }
    }

    finisher() {
        if (this.globals.restaurant.plg_articles_finisher === undefined || this.globals.restaurant.plg_articles_finisher === false) {
            this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                plg_articles_finisher: true
            });
            this.globals.restaurant.plg_articles_finisher = true;
            this.analyticsServices.trackingExpArticles('finisher', this.globals.tracking_exp['finisher'], '');
        }
    }

    translate() {
        if(!this.globals.checkLimitsByLicense('dishes', 'langs')) {
            this.navCtrl.push(AddonsTriggerVersionProPage);
            return;
        }
        //preguntar
        let alert = this.alertCtrl.create({
            title: this.translateService.instant('instant-traducir-plato'),
            message: this.translateService.instant('instant-traducir-auto-plato-message'),
            buttons: [
                {
                    text: this.translateService.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translateService.instant('general-si'),
                    handler: () => {
                        this.translateDish();
                    }
                }
            ]
        });
        alert.present();
    }

    async translateDish() {
        // Mostrar loader
        const loader = this.loadingCtrl.create({
            content: this.translateService.instant('instant-traduciendo') || 'Traduciendo...',
            dismissOnPageChange: false
        });
        await loader.present();

        try {
            // Obtener el idioma del restaurante, nombre y descripción del plato
            const restaurantLang = this.globals.restaurant.lang;
            const dishName = this.returnNameContent();
            const dishDescription = this.returnDescriptionContent();
            
            // Definir prompts según el idioma del restaurante
            const prompts = {
                'es': {
                    system: "Eres un experto traductor gastronómico. Debes traducir el nombre y descripción de un plato a 6 idiomas: español (es), inglés (en), francés (fr), alemán (de), italiano (it) y catalán (ca). Responde únicamente con un JSON válido que contenga las traducciones con las claves: names (para los nombres) y descriptions (para las descripciones), cada una con las claves: es, en, fr, de, it, ca. No añadas ningún texto adicional, solo el JSON.",
                    user: `Traduce el nombre y descripción de este plato:\nNombre: "${dishName}"\nDescripción: "${dishDescription}"\n\na los 6 idiomas mencionados. Responde solo con el JSON.`
                },
                'en': {
                    system: "You are an expert gastronomic translator. You must translate a dish name and description to 6 languages: Spanish (es), English (en), French (fr), German (de), Italian (it) and Catalan (ca). Respond only with a valid JSON containing the translations with keys: names (for names) and descriptions (for descriptions), each with keys: es, en, fr, de, it, ca. Do not add any additional text, just the JSON.",
                    user: `Translate the name and description of this dish:\nName: "${dishName}"\nDescription: "${dishDescription}"\n\nto the 6 mentioned languages. Respond only with the JSON.`
                },
                'fr': {
                    system: "Vous êtes un traducteur gastronomique expert. Vous devez traduire le nom et la description d'un plat en 6 langues : espagnol (es), anglais (en), français (fr), allemand (de), italien (it) et catalan (ca). Répondez uniquement avec un JSON valide contenant les traductions avec les clés : names (pour les noms) et descriptions (pour les descriptions), chacune avec les clés : es, en, fr, de, it, ca. N'ajoutez aucun texte supplémentaire, juste le JSON.",
                    user: `Traduisez le nom et la description de ce plat :\nNom : "${dishName}"\nDescription : "${dishDescription}"\n\ndans les 6 langues mentionnées. Répondez uniquement avec le JSON.`
                },
                'de': {
                    system: "Sie sind ein Experte für gastronomische Übersetzungen. Sie müssen den Namen und die Beschreibung eines Gerichts in 6 Sprachen übersetzen: Spanisch (es), Englisch (en), Französisch (fr), Deutsch (de), Italienisch (it) und Katalanisch (ca). Antworten Sie nur mit einem gültigen JSON, das die Übersetzungen mit den Schlüsseln enthält: names (für Namen) und descriptions (für Beschreibungen), jede mit den Schlüsseln: es, en, fr, de, it, ca. Fügen Sie keinen zusätzlichen Text hinzu, nur das JSON.",
                    user: `Übersetzen Sie den Namen und die Beschreibung dieses Gerichts:\nName: "${dishName}"\nBeschreibung: "${dishDescription}"\n\nin die 6 genannten Sprachen. Antworten Sie nur mit dem JSON.`
                },
                'it': {
                    system: "Sei un traduttore gastronomico esperto. Devi tradurre il nome e la descrizione di un piatto in 6 lingue: spagnolo (es), inglese (en), francese (fr), tedesco (de), italiano (it) e catalano (ca). Rispondi solo con un JSON valido contenente le traduzioni con le chiavi: names (per i nomi) e descriptions (per le descrizioni), ciascuna con le chiavi: es, en, fr, de, it, ca. Non aggiungere alcun testo aggiuntivo, solo il JSON.",
                    user: `Traduci il nome e la descrizione di questo piatto:\nNome: "${dishName}"\nDescrizione: "${dishDescription}"\n\nnelle 6 lingue menzionate. Rispondi solo con il JSON.`
                },
                'ca': {
                    system: "Ets un traductor gastronòmic expert. Has de traduir el nom i la descripció d'un plat a 6 idiomes: espanyol (es), anglès (en), francès (fr), alemany (de), italià (it) i català (ca). Respon únicament amb un JSON vàlid que contingui les traduccions amb les claus: names (per als noms) i descriptions (per a les descripcions), cadascuna amb les claus: es, en, fr, de, it, ca. No afegeixis cap text addicional, només el JSON.",
                    user: `Traduïu el nom i la descripció d'aquest plat:\nNom: "${dishName}"\nDescripció: "${dishDescription}"\n\nals 6 idiomes esmentats. Respon només amb el JSON.`
                }
            };

            // Obtener el prompt correspondiente al idioma del restaurante
            const prompt = prompts[restaurantLang] || prompts['en']; // Fallback a inglés si no existe el idioma

            const messages = [
                {
                    "role": "system",
                    "content": prompt.system
                },
                {
                    "role": "user",
                    "content": prompt.user
                }
            ];

            // Configurar el formato de respuesta JSON
            const response_format = { "type": "json_object" };

            // Llamar a DeepSeek
            const response = await this.aiServices.deepseekOpenAIGenerateText(response_format, messages);
            
            // Procesar la respuesta
            if (response && response['choices'] && response['choices'][0] && response['choices'][0]['message']) {
                const content = response['choices'][0]['message']['content'];
                const translations = JSON.parse(content);

                // Actualizar el formulario de nombres
                if (translations.names) {
                    this.dishServices.form.patchValue({
                        name_es: translations.names['es'][0].toUpperCase() + translations.names['es'].substring(1) || '',
                        name_en: translations.names['en'][0].toUpperCase() + translations.names['en'].substring(1) || '',
                        name_fr: translations.names['fr'][0].toUpperCase() + translations.names['fr'].substring(1) || '',
                        name_it: translations.names['it'][0].toUpperCase() + translations.names['it'].substring(1) || '',
                        name_de: translations.names['de'][0].toUpperCase() + translations.names['de'].substring(1) || '',
                        name_ca: translations.names['ca'][0].toUpperCase() + translations.names['ca'].substring(1) || ''
                    });
                }

                // Actualizar el formulario de descripciones
                if (translations.descriptions) {
                    this.dishServices.form_desc.patchValue({
                        description_es: translations.descriptions['es'] === 'null' ? '' : translations.descriptions['es'],
                        description_en: translations.descriptions['en'] === 'null' ? '' : translations.descriptions['en'],
                        description_fr: translations.descriptions['fr'] === 'null' ? '' : translations.descriptions['fr'],
                        description_it: translations.descriptions['it'] === 'null' ? '' : translations.descriptions['it'],
                        description_de: translations.descriptions['de'] === 'null' ? '' : translations.descriptions['de'],
                        description_ca: translations.descriptions['ca'] === 'null' ? '' : translations.descriptions['ca']
                    });
                }
            }

            // Ocultar loader al completar exitosamente
            loader.dismiss();

        } catch (error) {
            // Ocultar loader en caso de error
            loader.dismiss();
            
            console.error('Error al traducir con DeepSeek:', error);
            // Mostrar mensaje de error al usuario
            let alert = this.alertCtrl.create({
                title: this.translateService.instant('general-error'),
                message: this.translateService.instant('instant-traducir-error') || 'Error al traducir el plato',
                buttons: ['OK']
            });
            alert.present();
        }
    }

    returnNameContent() {
        switch (this.globals.restaurant.lang) {
            case 'es': {
                return this.dishServices.form.value.name_es;
            }
            case 'en': {
                return this.dishServices.form.value.name_en;
            }
            case 'fr': {
                return this.dishServices.form.value.name_fr;
            }
            case 'de': {
                return this.dishServices.form.value.name_de;
            }
            case 'it': {
                return this.dishServices.form.value.name_it;
            }
            case 'ca': {
                return this.dishServices.form.value.name_ca;
            }
        }
    }

    returnDescriptionContent() {
        switch (this.globals.restaurant.lang) {
            case 'es': {
                return this.dishServices.form_desc.value.description_es;
            }
            case 'en': {
                return this.dishServices.form_desc.value.description_en;
            }
            case 'fr': {
                return this.dishServices.form_desc.value.description_fr;
            }
            case 'de': {
                return this.dishServices.form_desc.value.description_de;
            }
            case 'it': {
                return this.dishServices.form_desc.value.description_it;
            }
            case 'ca': {
                return this.dishServices.form_desc.value.description_ca;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-name/dish-create-name.ts